import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class IntercomUserService {
    private readonly STORAGE_KEY_USER_ID = 'intercom-selected-user-id';
    private readonly STORAGE_KEY_USER_NAME = 'intercom-selected-user-name';
    private readonly RISE_EMAIL = 'hello@rise-media.com';
    private hasShownModalThisSession = false;

    constructor() {
    }

    isRiseUser(email: string): boolean {
        return email?.toLowerCase() === this.RISE_EMAIL;
    }

    hasShownModal(): boolean {
        return this.hasShownModalThisSession;
    }

    setModalShown(): void {
        this.hasShownModalThisSession = true;
    }

    getSelectedUserId(): string | null {
        return localStorage.getItem(this.STORAGE_KEY_USER_ID);
    }

    getSelectedUserName(): string | null {
        return localStorage.getItem(this.STORAGE_KEY_USER_NAME);
    }

    clearSelectedUser(): void {
        localStorage.removeItem(this.STORAGE_KEY_USER_ID);
        localStorage.removeItem(this.STORAGE_KEY_USER_NAME);
        this.hasShownModalThisSession = false;
    }
}
